import VueI18n from 'vue-i18n';
import locales from '~/data/locales.json';

export default class LocalizationUtils {
    static getLocaleFromURL(): string {
        return window.location.pathname.replace(/^\/([^/]+).*/i, '$1');
    }

    static isLocaleSupported(locale: string): boolean {
        return locales.map(l => l.locale).includes(locale);
    }

    static replaceLocaleInURL(locale: string): string {
        const path = window.location.pathname;

        // Trim locale from path
        const pathWithoutLocale = path.replace(/^\/[^/]+/, '');

        // Redirect to correct locale
        return `/${locale}${pathWithoutLocale}`;
    }

    static buildURLWithLocale(path: string): string {
        const locale = LocalizationUtils.getLocaleFromURL();
        return `/${locale}${path}`;
    }

    static async loadLocaleMessages(i18n: VueI18n, locale: string) {
        if (!i18n.availableLocales.includes(locale)) {
            const messages = await import(`./text/${locale}/index.js`);
            if (messages) {
                i18n.setLocaleMessage(locale, messages.default);
            }
        }
    }

    static async loadlLocaleMoment(locale: string) {
        return import(`moment/locale/${locale}`);
    }
}
